import { PureComponent } from 'react';
import { StyledSingleConnector, StyledConnectorLine, StyledSingleConnectorButton } from 'automation-ui-directed-graph/ConnectorStyledComponents';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class SingleConnector extends PureComponent {
  render() {
    const {
      children,
      color,
      edgeThickness
    } = this.props;
    return /*#__PURE__*/_jsxs(StyledSingleConnector, {
      children: [/*#__PURE__*/_jsx(StyledConnectorLine, {
        color: color,
        edgeThickness: edgeThickness
      }), /*#__PURE__*/_jsx(StyledSingleConnectorButton, {
        children: children
      })]
    });
  }
}
export default SingleConnector;